import { Outlet } from 'react-router-dom';
import adminBackground from '../assets/admin-bg.png';
import { useState } from 'react';
import ReactModal from 'react-modal';
import Spinner from '../share/Spinner';
import useAdminUser from '../contexts/AdminUserContext';
import { LoadingContext } from '../contexts/LoadingContext';
import { useTranslation } from 'react-i18next';

function AdminNavBar({ isLogin }: { isLogin: boolean }) {
  const [t] = useTranslation(['common']);
  const adminUser = useAdminUser();

  return (
    <nav className="fixed top-0 z-50 bg-group-primary text-white h-[60px] w-full px-10 xl:px-60">
      <div className="grid h-full w-full grid-cols-6">
        <span className="text-2xl flex justify-center items-center col-start-2 col-span-4">
          {t('admin_title', '安麗活動群組管理系統')}
        </span>
        {isLogin ? (
          <button
            className="flex justify-end items-center"
            onClick={adminUser.logout}
          >
            <span className="material-symbols-outlined">logout</span>
            {t('signout', '登出')}
          </button>
        ) : (
          <></>
        )}
      </div>
    </nav>
  );
}

export default function AdminContainer() {
  const adminUser = useAdminUser();
  const [isLoading, setIsLoading] = useState(false);
  const style = {
    backgroundImage: `url(${adminBackground})`,
  };
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      <div className="min-h-screen w-screen bg-repeat-round" style={style}>
        <AdminNavBar isLogin={adminUser.isLogin} />
        <div className="xl:mx-60 pt-[60px] h-full w-auto mx-4">
          <Outlet />
        </div>
      </div>
      <ReactModal
        isOpen={isLoading}
        overlayClassName="z-[1001] fixed bg-white/[.4] inset-0 backdrop-blur-sm"
        className="flex h-full w-full justify-center items-center px-5"
      >
        <Spinner />
      </ReactModal>
    </LoadingContext.Provider>
  );
}
